import { useTranslation } from 'react-i18next';
import React from 'react';
import { EditPositionPreferencesSection } from '../edit-position-preferences-section/edit-position-preferences-section.component';
import STRING_KEYS from '../../../../language/keys';
import { EditPositionAutocomplete }
  from '../../../../modules/create-position/components/autocompletes/position-autocomplete/edit-position-autocomplete/edit-position-autocomplete.component';

export const PositionTitleSection = ({
  jobTitle,
  changeHandler,
  completeHandler,
}: PositionTitleSectionProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <EditPositionPreferencesSection
      emoji="💼"
      title={ translate(STRING_KEYS.EDIT_POSITION_PREFERENCES_DIALOG.SECTIONS.POSITION_TITLE) }
    >
      <EditPositionAutocomplete
        jobTitle={ jobTitle }
        changeHandler={ changeHandler }
        completeHandler={ completeHandler }
      />
    </EditPositionPreferencesSection>
  );
};
